module.exports = {
  purge: [
    './src/**/*.vue',
    './src/**/*.js',
  ],
  theme: {
    extend: {
      colors: {
        primary_dark: '#016960', //green
        primary_dark_alt: '#004B45',
        primary_light: '#B1E9EF', //seafoam
        primary_light_alt: '#B1E9EF',
        accent_light: '#F6BB5C', //yellow
        accent_light_alt: '#F6BB5C', //yellow
        accent_dark: '#373737', //dark gray
        accent_dark_alt: '#373737', //dark gray
      },
      fontSize: {
        '2r': '2rem',
        }
    },
  },
  variants: {
    backgroundColor: ['responsive','hover', 'focus', 'odd'],
  },
  plugins: [],
}
